import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from "react";
// components
import { StyledAccordionBody, StyledWrapper, Placeholder } from "./accordionbody.styles";
export const AccordionBody = ({ children, opened, iconAlignment, stylingType, fontSize = "p2", contentPreviewId, }) => {
    const ref = useRef(null);
    const isIconRight = iconAlignment === "right";
    return (_jsx(StyledWrapper, Object.assign({ stylingType: stylingType, isIconRight: isIconRight, opened: opened, ref: ref }, { children: _jsxs(StyledAccordionBody, Object.assign({ stylingType: stylingType, isIconRight: isIconRight, opened: opened, fontSize: fontSize, "data-preview-id": contentPreviewId }, { children: [_jsx(Placeholder, { height: 4 }), children, _jsx(Placeholder, { height: 16 })] })) })));
};
